import { ref } from 'vue';
import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';

export type WeekDay = 0 | 1 | 2 | 3 | 4 | 5 | 6;

const isValidWeekDay = (value: number): value is WeekDay => {
    return value >= 0 && value <= 6;
};

const isValidConfig = (config: unknown): config is { startWeekOn: number } => {
    return Boolean(
        config &&
        typeof config === 'object' &&
        'startWeekOn' in config
    );
};

export const useWeekStartDay = () => {
    const weekStartDay = ref<WeekDay>(1); // Default to Monday
    const isLoading = ref(false);

    const fetchWeekStartDay = async () => {
        if (isLoading.value) return; // Prevent duplicate calls
        
        isLoading.value = true;
        try {
            const config = await fetchFromLambda('/organisation/organisations/me', { cacheKey: 'organisation-week-start' });

            if (!isValidConfig(config)) return;

            const startWeekOn = Number(config.startWeekOn);
            if (isValidWeekDay(startWeekOn)) {
                weekStartDay.value = startWeekOn;
            }
        } catch {
            // Failed to fetch week start day, using default
        } finally {
            isLoading.value = false;
        }
    };

    return {
        weekStartDay, isLoading, fetchWeekStartDay
    };
};
